import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Formatacao from '@/app/util/formatacao';
import './notasEmpenho.css'
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

function NotasEmpenhoTable( {list} ){

    const [state, setState] = React.useState({
        pagamentos: [],
        showPagamentos: false
    })

    const visualizarPagamentos = (nota) => {
        setState({
            pagamentos: nota.notasPagamento,
            showPagamentos: false
        })
    }

    return(
        <React.Fragment>
            <DataTable value={list}>
                <Column  header="Número" body={
                    (item) => <span>{`${item.numero}/${item.ano}`}</span>
                } className="t-center colunaNumero" />
                <Column field="descricao" header="Descrição" />
                <Column header="Valor" body={
                    (item) => <span>{Formatacao.currency(item.valor)}</span>
                } className="t-right colunaValor" />
            </DataTable>

            <Dialog visible={state.showPagamentos} header={"Notas de Pagamento"} onHide={e => setState({showPagamentos: false})}>
                <DataTable value={state.pagamentos}>
                    <Column  header="Número" body={
                        (item) => <span>{`${item.numero}/${item.ano}`}</span>
                    } className="t-center colunaNumero" />
                    <Column header="Valor" body={
                        (item) => <span>{Formatacao.currency(item.valor)}</span>
                    } className="t-right colunaValor" />
                </DataTable>
            </Dialog>
       </React.Fragment>
    )
}

export default NotasEmpenhoTable;
